import { useState } from "react";
import { useTranslation } from "react-i18next";
import { RowInfo } from "../../common";
import { Textarea } from "../../common/Textarea";
import TextTransformationModal from "../modals/TextTransformationModal";
import { subtypeFromPrompt } from "../transformationPrompt";

const Text = ({ useQuery, showTransformation = false }) => {
    const { t } = useTranslation();
    const [collection, setCollection] = useQuery();
    const [localPrompt, setLocalPrompt] = useState(collection.prompt);

    const setPrompt = (value) => {
        const prompt = (value || '').trim();
        setCollection({
            prompt,
            task_subtype: subtypeFromPrompt(prompt),
        });

        if (value?.length > 0) {
            setLocalPrompt(value);
        }
    };

    return (
        <>
            <p dangerouslySetInnerHTML={{ __html: t('Require the player to type words.') }} />
            {
                showTransformation
                    ? (
                        <RowInfo help={<TextTransformationModal />}>
                            <Textarea
                                label={t("Transformation Instructions")}
                                name="prompt"
                                rows={5}
                                mode="clean"
                                defaultValue={localPrompt}
                                setValue={setPrompt}
                                onChange={setLocalPrompt}
                                className="form-control reset-form-control"
                                stripHtml={true}
                                required
                                placeholder={t("Example: A watercolor painting of whatever the player wrote.")}
                            />
                        </RowInfo>
                    )
                    : null
            }
        </>
    );
};

export default Text;
